import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Image } from '../../molecules/Image/render';
import block from './block.json';
import { getStyles } from './styles.css';

export type PageHeaderTwoColumnsProps = {
	variant?: string;
	title?: string;
	introduction?: string;
	backgroundImage?: ImageProps;
	backgroundImageLandscape?: ImageProps;
} & ThemeProps &
	ChildrenProps;

/**
 * COMPONENT
 */
export const PageHeaderTwoColumns: FC<PageHeaderTwoColumnsProps> &
	BlockConfigs = ({
	title,
	introduction,
	backgroundImage,
	backgroundImageLandscape,
	children,
	variant: currentVariant = 'default',
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(
		block.slug,
		theme,
		currentVariant
	);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-pageHeader supt-pageHeaderTwoColumns',
		`supt-pageHeader--${variant}`,
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			<div className="supt-pageHeaderTwoColumns__inner">
				{title && (
					<h1
						className="supt-pageHeaderTwoColumns__title"
						dangerouslySetInnerHTML={{ __html: title }}
					/>
				)}
				{introduction && (
					<p
						className="supt-pageHeaderTwoColumns__introduction"
						dangerouslySetInnerHTML={{ __html: introduction }}
					/>
				)}
				<div className="supt-pageHeaderTwoColumns__content">
					{children}
				</div>
			</div>
			{backgroundImage?.src ? (
				<Image
					src={backgroundImage.src}
					width={backgroundImage?.width}
					height={backgroundImage?.height}
					sizes="(min-width: 1440px) 50vw, 100vw"
					priority
					className="supt-pageHeaderTwoColumns__backgroundImage"
				/>
			) : null}
			{backgroundImageLandscape?.src ? (
				<Image
					src={backgroundImageLandscape.src}
					width={backgroundImageLandscape?.width}
					height={backgroundImageLandscape?.height}
					sizes="100vw"
					priority
					className="supt-pageHeaderTwoColumns__backgroundImageLandscape"
					// layout="fill"
					// objectFit="cover"
				/>
			) : null}
		</div>
	);
};

PageHeaderTwoColumns.slug = block.slug;
PageHeaderTwoColumns.title = block.title;
